import React from 'react'
import Navigation from '/js/views/shared/components/navigation'
import Header from '/js/views/shared/components/header'
import Hero from '/js/views/shared/components/hero'
import Intro from '/js/views/shared/components/intro'

class MissingPageLayout extends React.Component {
  render() {
    const { shared, currentPage, routes, pageData, theme } = this.props

    return (
      <>
        <Navigation
          navigation={shared.navigation}
          social={shared.social}
          currentPage={currentPage}
          routes={routes}
          theme={theme}
        />
        <Header
          header={shared.header}
          theme={theme}
          currentPage={currentPage}
          routes={routes}
        />

        <div data-label="content-page-layout">
          <Hero hero={pageData.hero} graphic={pageData.graphic} theme={theme} />
          <Intro intro={pageData.intro} theme={theme} />
        </div>
      </>
    )
  }
}

export default MissingPageLayout
